<style lang="less">
.draw-com-container {
  width: 750px;
  height: 100%;
  background: #f7f7f7;
  font-family: PingFangSC-Semibold;
  .detail-main {
    padding: 16px;
    width: 718px;
    .village {
      padding: 24px;
      margin-top: 18px;
      .village-progress {
        margin-top: 10px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        .title-wrapper {
          float: left;
          width: 260px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        }
        .progress-title {
          height: 40px;
          font-size: 26px;
          color: rgba(137, 147, 159, 1);
          line-height: 40px;
          margin-bottom: 5px;
        }
        .progress_wrapper {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
        .progress {
          width: 400px;
          height: 26px;
          color: #f5a623;
        }
        .van-progress {
          background: #f7f7f7;
        }
        .van-progress__portion--with-pivot {
          border-radius: 14px;
        }
      }
    }
    .industry-development {
      padding: 24px;
      .development-box-wrapper {
        margin: 34px 34px 0;
      }
      .development-echarts {
        position: relative;
        width: 670px;
        height: 600px;
        .pie-echarts{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .detail-footer {
    height: 102px;
    line-height: 102px;
    text-align: center;
    color: rgba(49, 45, 45, 1);
    font-size: 26px;
  }
}
.title {
  font-size: 32px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(35, 44, 55, 1);
  line-height: 44px;
  text-align: left;
}
.common-box-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  .one{
    margin-right: 80px;
  }
  .two{
    margin-left: 80px;
  }
  .common-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .common-title {
      height: 36px;
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(137, 147, 159, 1);
      line-height: 36px;
      margin-bottom: 10px;
    }
    .common-info {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(35, 44, 55, 1);
      line-height: 44px;
    }
  }
}
.main-wrapper {
  background: #fff;
  width: 670px;
  box-shadow: 0px 0px 4px 0px rgba(219, 219, 219, 0.5);
  border-radius: 6px;
}
</style>
<template>
  <div class="draw-com-container">
    <div class="detail-main">
      <div class="industry-development main-wrapper">
        <div class="title">行业分布</div>
        <div class="development-echarts" v-if="industryList.length>0">
          <Pie id="industry" class="pie-echarts" text="企业" :pieData="industryList"></Pie>
        </div>
        <div style="text-align:center;margin:20px 0;" v-else>暂无数据</div>
      </div>
      <div class="industry-development main-wrapper" style="margin-top: 18px;">
        <div class="title">薪资分布</div>
        <div class="development-box-wrapper common-box-wrapper">
          <!-- <div class="development-box common-box one">
            <div class="development-title common-title">平均租金</div>
            <div class="development-info common-info">{{salaryInfo.avgRent}}元/平米</div>
          </div>
          <div class="development-box common-box two">
            <div class="development-title common-title">平均工资</div>
            <div class="development-info common-info">{{salaryInfo.avgPay}}元</div>
          </div> -->
          <!-- <div class="development-box common-box">
            <div class="development-title common-title">租金收入比</div>
            <div class="development-info common-info">{{salaryInfo.radio}}</div>
          </div> -->
        </div>
        <div class="development-echarts" v-if="salaryList.length>0">
          <Pie id="salary" class="pie-echarts" text="工作人群" :pieData="salaryList"></Pie>
        </div>
        <div style="text-align:center;margin:20px 0;" v-else>暂无数据</div>
      </div>
      <div class="village main-wrapper">
        <div class="title">职位分布</div>
        <div class="village-progress" v-for="(item,index) in jobList" :key="index">
          <div class="title-wrapper">
            <div class="progress-title" style="margin-right:10px;">{{item.job}}</div>
            <div class="progress-title">{{item.averagePay}}</div>
          </div>
          <div class="progress_wrapper">
          <Progress
            class="progress"
            :percentage="item.jobCount<=30?item.jobCount*3:item.jobCount>30&&item.jobCount<50?item.jobCount*2:item.jobCount>50&&item.jobCount<75?item.jobCount*1.5:item.jobCount"
            :pivot-text="item.jobCount+'%'"
            text-color="#F5A623"
            pivot-color="rgba(255,255,255,0)"
            color="#F5A623"
          />
          </div>
        </div>
      </div>
    </div>
    <div class="detail-footer">更新时间：{{salaryInfo.updateTime}}</div>
  </div>
</template>

<script>
import { Progress } from "vant";
import Pie from "@/components/echarts_pie"
let timestampStart,timestampEnd;
export default {
  name: "draw-company",
  components: {
    Progress,Pie
  },
  data() {
    return {
      salaryList:[],
      salaryInfo:{},
      industryList:[],
      jobList:[]
    };
  },
  created() {
    timestampStart = (new Date()).getTime();
    this.addBuried({
      source:'1',
      eventType: '曝光事件',
      eventContent: '画圈企业信息'
    });
    let options = this.$route.query
    this.getIndustryInfo(options.polyline);
    this.getSalaryInfo(options.polyline);
    this.getJobInfo(options.polyline);
  },
  mounted() {},
  methods: {
    //获取行业分布信息
    async getIndustryInfo(polyline) {
      await this.$axios
        .post("api/xz/draw/industry/distribution/", {
          polyline: polyline
        })
        .then(res => {
          if (res.success) {
            this.industryList = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取薪资分布信息
    async getSalaryInfo(polyline) {
      await this.$axios
        .post("api/xz/draw/pay/distribution/", {
          polyline: polyline
        })
        .then(res => {
          if (res.success) {
            this.salaryList = res.result.items;
            this.salaryInfo = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取职位分布信息
    async getJobInfo(polyline) {
      await this.$axios
        .post("api/xz/draw/job/distribution/", {
          polyline: polyline
        })
        .then(res => {
          if (res.success) {
            this.jobList = res.result;
            let total = 0;
            for (let i = 0; i < this.jobList.length; i++) {
              this.jobList[i].averagePay =
                (this.jobList[i].averagePay / 1000).toFixed(1) + "k";
              total = total + this.jobList[i].jobCount;
            }
            for (let i = 0; i < this.jobList.length; i++) {
              this.jobList[i].jobCount = (
                (this.jobList[i].jobCount / total) *
                100
              ).toFixed(2);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  destroyed () {
    timestampEnd = (new Date()).getTime();
    let residenceTime = timestampEnd-timestampStart;
    this.addBuried({
      source:'1',
      eventType: '页面停留时长',
      eventContent: '画圈企业信息页停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/draw_company_details/index.vue